export enum Stain {
  MethyleneBlue = 1,
  MethyleneViolet = 2,
  MethyleneVioletBeta = 21,
}

export enum CellSize {
  Small = 1,
  Medium = 2,
  Large = 3,
  All = 4,
}

export enum SugarUnit {
  Oechsle = 0,
  Brix = 1,
  Kmw = 2,
  Baume = 3,
  DensityGpl = 4,
}

export enum CameraType {
  Oculyze = 1,
  Lab = 2,
}

export enum ChamberDepth {
  O_1 = 0.1,
  O_2 = 0.2,
  O_25 = 0.25,
  O_5 = 0.5,
}

export enum SquareSize {
  O_0025 = 0.0025,
  O_0625 = 0.0625,
  O_04 = 0.04,
}

export enum BuddingMethods {
  ALL_CELLS = 'all',
  BUDDING_ONLY = 'budding_only',
}

export enum BuddingSensitivity {
  LOW = 'low', // 0
  HIGH = 'high', // 1
  VERY_HIGH = 'very_high', // 2
}
